export enum Screen {
	DESKTOP = 0,
	MOBILE = 1
}
